export enum Roles {
    SuperAdmin = 'Super Admin',
    Admin = 'Admin',
    User = 'Testers',
    Reader = 'Reader'
}
